

import moment from 'moment';

class GatUtils{

   static makeUrlParams(baseUrl,params){
     let result = baseUrl;

     let sep='?';
     for (var propName in params) {
        result = result+sep+propName+'='+params[propName];
        sep = '&'
     }

    return result;
   }

   static makeCopyViaJson(obj){
     let result = {};
     if(obj){
      let jsonStr = JSON.stringify(obj);
      result = JSON.parse(jsonStr);
     }
     return result;
   }

   static lookupCode(code,list, codeField = 'value', textField = 'text'){
     let result = code;
     if(list && list.length > 0){
      let record = list.find(item=>{
        if(item[codeField] == code){
          return item;
        }
      });
      if(record){
        result = record[textField];
      }
     }

     return result;
   }

   static formatDate(date){
      let m = moment(date);
      if( m.isValid()){
        return m.format('DD.MM.YYYY');
      }
   }

   static formatDateTime(date){
    let m = moment(date);
    if( m.isValid()){
      return m.format('DD.MM.YYYY HH:mm');
    }
 }

 static combineDateAndTime(date,time){
    let datetime = null;
    date = moment.utc(date).toDate();
    time = moment.utc(time).toDate();
    if(date != null && date != null){
       datetime = new Date(Date.UTC(date.getFullYear(),date.getMonth(),date.getDate(),time.getHours(),time.getMinutes(),time.getSeconds()));
    }
    return datetime;
 }

  static setTimeOnDate(date,time){
    let datetime = null;
    if(date != null && time != null){
      date = moment.utc(date).toDate();
      time = moment.utc(time).toDate();
      datetime = new Date(Date.UTC(date.getFullYear(),date.getMonth(),date.getDate(),time.getHours(),time.getMinutes(),time.getSeconds()));
    }
    return datetime;
  }

}

export default GatUtils;
